import styled from 'styled-components';

import Button from '@material-ui/core/Button';

const StyledLoginButton = styled(Button)`
    border-color: #ffffff;
    border: '2px solid';
    font-family: Open Sans !important;
    font-weight: 600 !important;
    font-size: 14px !important;
    line-height: 175% !important;
    letter-spacing: 0.75px !important;
    margin-left: .8rem !important;
    margin-right: .8rem !important;
    padding-left: 15px !important;
    padding-right: 15px !important;    
    color:  ${({ theme }) => theme.palette.primary.main} !important;
    background-color: #ffffff !important;
`;

export { StyledLoginButton };
